import { render, staticRenderFns } from "./PicShow.vue?vue&type=template&id=c594e6ea&scoped=true&"
import script from "./PicShow.vue?vue&type=script&lang=ts&"
export * from "./PicShow.vue?vue&type=script&lang=ts&"
import style0 from "./PicShow.vue?vue&type=style&index=0&id=c594e6ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c594e6ea",
  null
  
)

export default component.exports